var _rect, _rect2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBdMarker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.88157,
    y: 0.497781,
    width: 39.0455,
    height: 39.0455,
    rx: 19.5227,
    fill: "#F46940"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.88157,
    y: 0.497781,
    width: 39.0455,
    height: 39.0455,
    rx: 19.5227,
    stroke: "white",
    strokeWidth: 0.954545
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4902 8.60627C20.5375 8.60051 20.5845 8.59885 20.631 8.601C20.6742 8.59952 20.7179 8.60133 20.7617 8.60667C25.3542 9.16669 33.5939 16.7126 32.5326 19.368L32.5185 19.4037C32.4811 19.4987 32.4431 19.5953 32.3755 19.6712C32.1248 19.9526 31.3525 20.1566 30.226 20.3006V27.9094C30.226 28.7329 29.5584 29.4005 28.7348 29.4005H12.5171C11.6936 29.4005 11.026 28.7329 11.026 27.9094V20.3002C9.89947 20.1562 9.12713 19.9522 8.87643 19.6708C8.80885 19.5949 8.77086 19.4983 8.73346 19.4033L8.71936 19.3676C7.65809 16.7122 15.8978 9.16629 20.4902 8.60627Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.626 29.4005H16.626V23.2643C16.626 22.2349 17.4605 21.4004 18.4899 21.4004H22.7621C23.7915 21.4004 24.626 22.2349 24.626 23.2643V29.4005Z",
    fill: "#F46940"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBdMarker);
export default __webpack_public_path__ + "static/media/BDMarker.be2712fc2c5e0f266e89a80e07037243.svg";
export { ForwardRef as ReactComponent };